/*
 * File: NewVitals.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/05/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles showing the vitals form
 */
import React, { useState, useEffect } from "react";
import FormBuilder from "components/form-builder";
import VitalsFields from "../store/VitalsFields";
import VitalsModel from "../store/VitalsModel";
import PatientIdStore from "services/patients/store/PatientIdStore";
import FormStore from "components/form-builder/FormStore";
import PropTypes from "prop-types";
import UIProgress from "components/ui/UIProgress";
import { differenceInYears } from "date-fns";

const NewVitals = ({ patient, parentCallBack, toggleDialog }) => {
  const [loading, setLoading] = useState(true);
  const vitals = VitalsModel.create();
  let formFields = VitalsFields.slice(0);
  const formStore = FormStore.create();

  useEffect(() => {
    formStore.setFields(formFields);
    const addHeadCircumference = () => {
      const birthdate = patient.birthdate;
      const patientAge = differenceInYears(new Date(), birthdate);
      if (!birthdate || patientAge <= 3) {
        formFields.push({
          name: "headCircumference",
          label: "Head Circumference (cm)",
          type: "decimal"
        });
      }
    };
    addHeadCircumference();
    formStore.setFields(formFields);
    setLoading(false);
  }, [formFields, formStore, vitals, patient.birthdate]);

  const onChange = (key, val) => {
    vitals.changeField(key, val);
  };

  const onSubmit = async () => {
    toggleDialog();
    const patientId = PatientIdStore.getId();
    const newVitalsObj = await vitals.saveNewVitals(patientId);
    parentCallBack(newVitalsObj);
  };

  const customValidate = formStore => {
    vitals.validateFullForm(formStore);
  };

  if (loading) return <UIProgress />;
  return (
    <FormBuilder
      formStore={formStore}
      data={vitals}
      parentOnChange={onChange}
      parentOnSubmit={onSubmit}
      customValidate={customValidate}
    />
  );
};

NewVitals.propTypes = {
  patient: PropTypes.object.isRequired,
  parentCallBack: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired
};

export default NewVitals;
